import mixpanel from 'mixpanel-browser';

const initializeMixpanel = () => {
  try {
    const token = process.env.REACT_APP_MIXPANEL_TOKEN;

    if (!token) {
      console.error('Mixpanel token is missing or invalid. Please provide a valid token.');
      return;
    }

    mixpanel.init(token);
  } catch (error) {
    console.error('Error initializing Mixpanel:', error);
  }
};

export const identify = ({ companyId, userId }) => {
  try {
    if (!companyId || !userId) {
      console.error('Missing required parameters for identifying user.');
      return;
    }

    mixpanel.identify(userId);
    mixpanel.register({
      companyId,
      // add other properties here if needed
    });
  } catch (error) {
    console.error('Error identifying user with Mixpanel:', error);
  }
};

const commonProps = {
  // add common properties here
};

export const trackPUAnalytics = (eventName, props = {}) => {
  try {
    mixpanel.track(eventName, {
      ...commonProps,
      ...props,
    });
  } catch (error) {
    console.error('Error tracking analytics with Mixpanel:', error);
  }
};

export const disableMixpanel = () => {
  try {
    mixpanel.disable();
  } catch (error) {
    console.error('Error disabling Mixpanel:', error);
  }
};

// Initialize Mixpanel when the module is loaded
initializeMixpanel();



// WEBPACK FOOTER //
// ./src/client/services/Mixpanel/index.js